import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { HeroAlert } from './HeroAlert';
import { HeroText } from './HeroText';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeroText,
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, align: 'center' },
  }, overrideReadOnly)
  .nameOverride('insight', {
    _component: () => HeroAlert,
  }, overrideReadOnly);
